import { useEffect } from 'react';
import usePlatform from './usePlatform';
import { PLATFORM_META, PLATFORMS } from 'constants/platform';

function getOrCreateTag(selector, tag, attrs = {}) {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  return el;
}

/**
 * Patches document title, favicon, theme-color, and manifest link
 * to match the detected platform. Call once at the app root.
 */
export default function usePlatformMeta() {
  const { platform } = usePlatform();

  useEffect(() => {
    const meta = PLATFORM_META[platform] ?? PLATFORM_META[PLATFORMS.VIRTUAL_PRO];

    document.title = meta.title;

    const faviconLink = getOrCreateTag("link[rel='icon']", 'link', { rel: 'icon' });
    faviconLink.setAttribute('type', meta.faviconType);
    faviconLink.setAttribute('href', meta.favicon);

    const themeColorMeta = getOrCreateTag("meta[name='theme-color']", 'meta', {
      name: 'theme-color',
    });
    themeColorMeta.setAttribute('content', meta.themeColor);

    const manifestLink = getOrCreateTag("link[rel='manifest']", 'link', { rel: 'manifest' });
    manifestLink.setAttribute('href', meta.manifestUrl);
  }, [platform]);
}
